import { css } from "styled-components";

export const A = css`
    position: relative;
    color: currentColor;
    display: inline-block;
    font-weight: inherit;
    text-transform: none;
    transition: all .4s;
    text-decoration: none;

    &::after {
        content: "";
        position: absolute;
        left: 0;
        top: 100%;
        background-color: currentColor;
        display: inline-block;
        width: 100%;
        height: 1px;
        max-width: 50px;
        transition: max-width .2s;
    }
    &:hover {
        text-decoration: none;
        opacity: 1;
        &:after {
            max-width: 100%;
        }
    }
`;
